import React, { FC } from 'react'
import Loader from '../../../components/common/loader/Loader'
import {
  ButtonDanger,
  ButtonLight,
  Modal,
  Text
} from 'front-end/src/components'
import { t, Trans } from '@lingui/macro'
import { notification } from '../../../components/common/notifications/Notifications'
import { PathwayRelatedInstances } from './PathwayRelatedInstances'
import { usePathwayRelatedInstancesQuery } from '../../manage-pathway-page/ManagePathwayPage.codegen'

export const PathwayUnpublishModal: FC<{
  onCanceled: () => void
  pathwayId: number | null
  onSubmitted?: () => void
  show?: boolean
}> = ({ onCanceled, pathwayId, onSubmitted, show }) => {
  if (!pathwayId) {
    return null
  }

  const { data, loading } = usePathwayRelatedInstancesQuery({
    variables: { id: pathwayId }
  })

  const pathway = data?.admin?.pathway

  if (!pathway || loading) {
    return <Loader />
  }

  const relatedInstancesCount =
    pathway.relatedCampaignsByActions.length +
    pathway.relatedCampaignsByFilters.length +
    pathway.relatedCertifications.length

  return (
    <Modal
      newDesign
      header={t`Are you sure you want to return this pathway to draft?`}
      show={show}
      controls={[
        <ButtonLight onClick={onCanceled} key={1}>
          <Trans>Cancel</Trans>
        </ButtonLight>,
        <ButtonDanger
          key={2}
          onClickAsync={async () => {
            onSubmitted && onSubmitted()
            notification.info(t`Pathway successfully returned to draft.`)
          }}
        >
          <Trans>Return to draft</Trans>
        </ButtonDanger>
      ]}
    >
      {relatedInstancesCount > 0 && (
        <>
          <Text pb="8px">
            <Trans>This pathway appears in the following instances.</Trans>
          </Text>
          <PathwayRelatedInstances pathway={pathway} />
        </>
      )}
    </Modal>
  )
}
